import { AnalyzeTab } from '@/features/analyze/components/AnalyzeTab';
import { SearchWithTranslation } from '@/components/Form/SearchWithTranslation';
import { useFilterConditionAtom } from '../atoms/filterCondition.atom';

export const AnalyzeHeader = () => {
  const [, setFilterCondition] = useFilterConditionAtom();

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <SearchWithTranslation
          onSuccess={(treatedText: string) => {
            setFilterCondition((prev) => ({
              ...prev,
              query: treatedText,
            }));
          }}
        />
      </div>

      <AnalyzeTab />
    </div>
  );
};
